import { SearchableSelect } from './SearchableSelect'
import { COUNTRIES, TOP_COUNTRIES } from '@/shared/data/countries'

interface CountrySelectProps {
  value: string | null
  onChange: (value: string) => void
  label?: string
  placeholder?: string
  searchPlaceholder?: string
  error?: string
  disabled?: boolean
  className?: string
}

const COUNTRY_OPTIONS = COUNTRIES.map((c) => ({
  value: c.code,
  label: c.name,
  prefix: c.flag,
  hint: c.code,
  searchTokens: c.dialCode,
}))

const TOP_COUNTRY_OPTIONS = TOP_COUNTRIES.map((c) => ({
  value: c.code,
  label: c.name,
  prefix: c.flag,
  hint: c.code,
  searchTokens: c.dialCode,
}))

export function CountrySelect({
  value,
  onChange,
  label,
  placeholder = 'Select country…',
  searchPlaceholder = 'Search country…',
  error,
  disabled,
  className,
}: CountrySelectProps) {
  return (
    <SearchableSelect
      label={label}
      value={value}
      onChange={onChange}
      options={COUNTRY_OPTIONS}
      topOptions={TOP_COUNTRY_OPTIONS}
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      error={error}
      disabled={disabled}
      className={className}
    />
  )
}
